import React, { useEffect, useState } from "react";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";
import config from "../../../config";
import GoogleAutocomplete from "../../../components/Common/GoogleAutoComplete";
import { Button, Col, Container, Form, Nav, Row, Tab } from "react-bootstrap";
import DriverListing from "./DriverListing";

const MapContainer = ({ google, viewData, lat, lng, name, onChange, data, handleAssignDriverModel, setAssignDriverModel, setAssignModelData ,address}) => {
  const [defaultLocation, setdefaultLocation] = useState();

  useEffect(() => {
    try {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(function (position) {
          setdefaultLocation({
            lat: lat ? lat : position.coords.latitude,
            lng: lng ? lng : position.coords.longitude,
          });
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  }, [lat, lng]);
  return (
    <>
      {/* <GoogleAutocomplete
                      // address={watch("address")}
                      lat={"lat"}
                      lng={"lng"}
                      name={"address"}
                      // name={"address"}
                      onChange={(e) => {
                        console.log(e);
                        handleAddress(e);
                      }}
                    /> */}
      <Col lg="12" className="my-2">
        <Row>
          <Col lg="4" className="my-2">
            <div className="py-2">
              <label htmlFor="" className="form-label m-0 fw-sbold">
                Location
              </label>
              {/* <Button className="d-flex align-items-center justify-content-center commonBtn h-auto">
                      Get Orders
                    </Button> */}
              <GoogleAutocomplete
                // address={watch("address")}
                lat={"lat"}
                lng={"lng"}
                name={"address"}
                value={address}

                // name={"address"}
                onChange={onChange}
              />
              {/* {errors?.address && (
                            <p className="text-danger m-0">
                              {errors?.address?.message}
                            </p>
                          )} */}
            </div>
            <div className="py-2">
              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey="Available"
              >
                <div className=" justify-content-between">
                  <Nav
                    variant="pills"
                    className="underlineTab border-bottom justify-content-center mb-3 w-100"
                  >
                    <Nav.Item className="w-50">
                      <Nav.Link
                        eventKey="Available"
                        className="bg-transparent position-relative fw-sbold text-center"
                      >
                        Available
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="w-50">
                      <Nav.Link
                        eventKey="Busy"
                        className="bg-transparent position-relative fw-sbold text-center"
                      >
                        Busy
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>

                <Tab.Content className="">
                  <Tab.Pane eventKey="Available">
                    <DriverListing
                      data={data}
                      type={"available"}
                      handleAssignDriverModel={handleAssignDriverModel}
                      setAssignModelData={setAssignModelData}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="Busy">
                    <DriverListing
                      data={data}
                      type={"busy"}
                      handleAssignDriverModel={handleAssignDriverModel}
                      setAssignModelData={setAssignModelData}
                    />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </Col>
          <Col lg="8" className="my-2">
            <div className="map">
              <div
                className="mapWrpper"
                style={{
                  height: "500px",
                }}
              >
                <Map
                  google={google}
                  zoom={10}
                  center={defaultLocation}
                  initialCenter={defaultLocation}
                >
                  {viewData?.map((item) => (
                    <Marker
                      position={{
                        lng: item.providerLocation.coordinates[0],
                        lat: item.providerLocation.coordinates[1],
                      }}
                    />
                  ))}
                </Map>
              </div>
            </div>
          </Col>
        </Row>
      </Col>

    </>
  );
};

export default GoogleApiWrapper({
  apiKey: config.googleMapKey,
})(MapContainer);
